module.exports = __webpack_public_path__ + "static/media/04_application_before_calc.4cd9a74a.png";